import { useState, useEffect } from "react";
import { GoogleKeys } from "../config/google";

const useCity = (defaultCity = "Jaipur") => {
    const [city, setCity] = useState(defaultCity);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    const API_KEY = GoogleKeys.GOOGLE_MAPS_API_KEY; // 🔑 Replace with your API key
                    const geoUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${API_KEY}`;

                    try {
                        const res = await fetch(geoUrl);
                        const data = await res.json();
                        if (data.results.length > 0) {
                            const addressComponents = data.results[0].address_components;
                            const cityComponent = addressComponents.find((comp) =>
                                comp.types.includes("locality")
                            );
                            if (cityComponent) {
                                setCity(cityComponent.long_name);
                            }
                        }
                    } catch (error) {
                        console.error("Error fetching city:", error);
                    }
                },
                (error) => {
                    console.error("Geolocation error:", error);
                }
            );
        }
    }, []);

    return city;
};

export default useCity;
